
import { PaymentStatusData } from "../types/payment-status";

interface GuestListProps {
  payment: PaymentStatusData;
}

export const GuestList = ({ payment }: GuestListProps) => {
  // Add null checks to prevent accessing properties of null
  if (!payment || !payment.player || !payment.booking) {
    return null;
  }

  return (
    <li key={payment.id}>
      <div className="text-gray-800">• {payment.player.full_name}</div>
      {payment.booking.guests?.map((guest) => (
        <div key={guest.id} className="text-gray-800">
          • {guest.name} <span className="text-xs text-gray-500">(guest)</span>
        </div>
      ))}
    </li>
  );
};
